import {
  cilUserPlus,
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cilAccountLogout,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilChart,
  cilChartPie,
  cilCheck,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCode,
  cilCommentSquare,
  cilContrast,
  cilCreditCard,
  cilCursor,
  cilDescription,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGrid,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilItalic,
  cilJustifyCenter,
  cilLanguage,
  cilLayers,
  cilList,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMediaRecord,
  cilMenu,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilSitemap,
  cilXCircle,
  cilSync,
  cilWarning,
  cilSearch,
  cilWalk,
  cilCash,
  cilEqualizer,
  cilBolt,
  cilBoltCircle,
  cilAsteriskCircle,
  cilMobile,
  cilPhone,
  cilChartLine,
  cilCheckCircle,
  cilX,
  cilCheckAlt,
  cilMoney,
  cilStorage,
  cilClock,
  cilVector,
  cilCalendarCheck,
  cilListRich,
  cilFactory,
  cilBarcode,
  cilContact,
  cilApps,
  cilLibrary,
  cilAlarm,
  cilInput,
  cilLink,
  cilCircle,
  cilGraph,
  cilRunning,
  cilBan,
  cilPowerStandby,
  cilLockUnlocked,
  cilTruck,
  cilDataTransferDown,
  cilArrowThickFromTop,
  cilBraille,
  cilBadge,
  cilPlus,
  cilArrowThickLeft,
  cilLoopCircular,
  cilChevronDoubleRight,
  cilArrowCircleBottom,
  cilCopy,
  cil3d,
  cilCart,
  cilBriefcase,
  cilLinkBroken,
  cilReload,
  cilInfo

} from '@coreui/icons';

import { signet } from './signet';
import { logo } from './logo';

export const iconSubset = {
  cilUserPlus,
  cilBadge,
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cilAccountLogout,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilChart,
  cilChartPie,
  cilCheck,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCode,
  cilCommentSquare,
  cilContrast,
  cilCreditCard,
  cilCursor,
  cilDescription,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGrid,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilItalic,
  cilJustifyCenter,
  cilLanguage,
  cilLayers,
  cilList,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMediaRecord,
  cilMenu,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  logo,
  signet,
  cilSitemap,
  cilXCircle,
  cilSync,
  cilWalk,
  cilWarning,
  cilSearch,
  cilCash,
  cilEqualizer,
  cilBolt,
  cilBoltCircle,
  cilAsteriskCircle,
  cilVector,
  cilX,
  cilClock,
  cilStorage,
  cilMoney,
  cilCheckCircle,
  cilCheckAlt,
  cilChartLine,
  cilPhone,
  cilMobile,
  cilCalendarCheck,
  cilListRich,
  cilFactory,
  cilBarcode,
  cilContact,
  cilApps,
  cilLibrary,
  cilAlarm,
  cilInput,
  cilLink,
  cilCircle,
  cilRunning,
  cilBan,
  cilPowerStandby,
  cilLockUnlocked,
  cilTruck,
  cilDataTransferDown,
  cilArrowThickFromTop,
  cilBraille,
  cilGraph,
  cilPlus,
  cilArrowThickLeft,
  cilLoopCircular,
  cilChevronDoubleRight,
  cilArrowCircleBottom,
  cilCopy,
  cil3d,
  cilCart,  cilBriefcase,
  cilLinkBroken,
  cilReload,
  cilInfo
};

export enum IconSubset {
  cilUserPlus = 'cilUserPlus',
  cibCcAmex = 'cibCcAmex',
  cibCcApplePay = 'cibCcApplePay',
  cibCcMastercard = 'cibCcMastercard',
  cibCcPaypal = 'cibCcPaypal',
  cibCcStripe = 'cibCcStripe',
  cibCcVisa = 'cibCcVisa',
  cibFacebook = 'cibFacebook',
  cibGoogle = 'cibGoogle',
  cibLinkedin = 'cibLinkedin',
  cibSkype = 'cibSkype',
  cibTwitter = 'cibTwitter',
  cifBr = 'cifBr',
  cifEs = 'cifEs',
  cifFr = 'cifFr',
  cifIn = 'cifIn',
  cifPl = 'cifPl',
  cifUs = 'cifUs',
  cilAccountLogout = 'cilAccountLogout',
  cilAlignCenter = 'cilAlignCenter',
  cilAlignLeft = 'cilAlignLeft',
  cilAlignRight = 'cilAlignRight',
  cilApplicationsSettings = 'cilApplicationsSettings',
  cilArrowBottom = 'cilArrowBottom',
  cilArrowRight = 'cilArrowRight',
  cilArrowTop = 'cilArrowTop',
  cilBasket = 'cilBasket',
  cilBell = 'cilBell',
  cilBold = 'cilBold',
  cilBookmark = 'cilBookmark',
  cilCalculator = 'cilCalculator',
  cilCalendar = 'cilCalendar',
  cilChart = 'cilChart',
  cilChartPie = 'cilChartPie',
  cilCheck = 'cilCheck',
  cilChevronLeft = 'cilChevronLeft',
  cilChevronRight = 'cilChevronRight',
  cilCloudDownload = 'cilCloudDownload',
  cilCode = 'cilCode',
  cilCommentSquare = 'cilCommentSquare',
  cilContrast = 'cilContrast',
  cilCreditCard = 'cilCreditCard',
  cilCursor = 'cilCursor',
  cilDescription = 'cilDescription',
  cilDollar = 'cilDollar',
  cilDrop = 'cilDrop',
  cilEnvelopeClosed = 'cilEnvelopeClosed',
  cilEnvelopeOpen = 'cilEnvelopeOpen',
  cilFile = 'cilFile',
  cilGrid = 'cilGrid',
  cilHome = 'cilHome',
  cilInbox = 'cilInbox',
  cilIndentDecrease = 'cilIndentDecrease',
  cilIndentIncrease = 'cilIndentIncrease',
  cilItalic = 'cilItalic',
  cilJustifyCenter = 'cilJustifyCenter',
  cilLanguage = 'cilLanguage',
  cilLayers = 'cilLayers',
  cilList = 'cilList',
  cilListNumbered = 'cilListNumbered',
  cilLocationPin = 'cilLocationPin',
  cilLockLocked = 'cilLockLocked',
  cilMagnifyingGlass = 'cilMagnifyingGlass',
  cilMap = 'cilMap',
  cilMediaPlay = 'cilMediaPlay',
  cilMediaRecord = 'cilMediaRecord',
  cilMenu = 'cilMenu',
  cilMoon = 'cilMoon',
  cilNotes = 'cilNotes',
  cilOptions = 'cilOptions',
  cilPaperclip = 'cilPaperclip',
  cilPaperPlane = 'cilPaperPlane',
  cilPen = 'cilPen',
  cilPencil = 'cilPencil',
  cilPeople = 'cilPeople',
  cilPrint = 'cilPrint',
  cilPuzzle = 'cilPuzzle',
  cilReportSlash = 'cilReportSlash',
  cilSave = 'cilSave',
  cilSettings = 'cilSettings',
  cilShare = 'cilShare',
  cilShareAll = 'cilShareAll',
  cilShareBoxed = 'cilShareBoxed',
  cilSpeech = 'cilSpeech',
  cilSpeedometer = 'cilSpeedometer',
  cilSpreadsheet = 'cilSpreadsheet',
  cilStar = 'cilStar',
  cilSun = 'cilSun',
  cilTags = 'cilTags',
  cilTask = 'cilTask',
  cilTrash = 'cilTrash',
  cilUnderline = 'cilUnderline',
  cilUser = 'cilUser',
  cilUserFemale = 'cilUserFemale',
  cilUserFollow = 'cilUserFollow',
  cilUserUnfollow = 'cilUserUnfollow',
  logo = 'logo',
  signet = 'signet',
  cilSitemap = 'cilSitemap',
  cilXCircle = 'cilXCircle',
  cilSync = 'cilSync',
  cilWarning = 'cilWarning',
  cilSearch = 'cilSearch',
  cilWalk = 'cilWalk',
  cilCash = 'cilCash',
  cilEqualizer = 'cilEqualizer',
  cilBolt = 'cilBolt',
  cilBoltCircle = 'cilBoltCircle',
  cilAsteriskCircle = 'cilAsteriskCircle',
  cilCalendarCheck = 'cilCalendarCheck',
  cilListRich = 'cilListRich',
  cilFactory = 'cilFactory',
  cilBarcode = 'cilBarcode',
  cilContact = 'cilContact',
  cilApps = 'cilApps',
  cilLibrary = 'cilLibrary',
  cilAlarm = 'cilAlarm',
  cilInput = 'cilInput',
  cilLink = 'cilLink',
  cilCircle = 'cilCircle',
  cilRunning = 'cilRunning',
  cilBan = 'cilBan',
  cilPowerStandby = 'cilPowerStandby',
  cilLockUnlocked = 'cilLockUnlocked',
  cilStorage = 'cilStorage',
  cilTruck = 'cilTruck',
  cilDataTransferDown = 'cilDataTransferDown',
  cilArrowThickFromTop = 'cilArrowThickFromTop',
  cilBraille = 'cilBraille',
  cilGraph = 'cilGraph',
  cilBadge = 'cilBadge',
  cilPlus = 'cilPlus',
  cilArrowThickLeft = 'cilArrowThickLeft',
  cilLoopCircular = 'cilLoopCircular',
  cilChevronDoubleRight = 'cilChevronDoubleRight',
  cilArrowCircleBottom = 'cilArrowCircleBottom',
  cilCopy = 'cilCopy',
  cil3d = 'cil3d',
  cilCart = 'cilCart', 
  cilBriefcase = 'cilBriefcase',
  cilLinkBroken = 'cilLinkBroken',
  cilReload = 'cilReload',
  cilInfo = 'cilInfo'

}
